module.exports = __webpack_public_path__ + "img/logo.40ec81a0.png";